<mat-card appearance="outlined">
  <mat-card-title [innerText]="'MAIN_APP_SERVICE_APP.mailRapportVersandErfassen' | translate"></mat-card-title>
  <mat-card-content [formGroup]="formGroupMailContent">
    <span class="row">
      <mat-form-field>
        <mat-label>{{ "MAIN_APP_SERVICE_APP.empfänger" | translate }}</mat-label>
        <input matInput [formControlName]="fldEmpfaengerKey" [id]="fldEmpfaengerKey" required />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ "MAIN_APP_SERVICE_APP.betreff" | translate }}</mat-label>
        <input matInput [formControlName]="fldBetreffKey" [id]="fldBetreffKey" />
      </mat-form-field>
    </span>

    <span class="row">
      <mat-form-field>
        <mat-label>{{ "MAIN_APP_SERVICE_APP.nachricht" | translate }}</mat-label>
        <input matInput [formControlName]="fldNachrichtKey" [id]="fldNachrichtKey" />
      </mat-form-field>
    </span>
  </mat-card-content>

  <mat-dialog-actions>
	  <button (click)="send()" [disabled]="!formGroupMailContent.valid" [innerText]="'MAIN_APP_SERVICE_APP.rapportSenden' | translate" class="confirm" mat-stroked-button></button>
    <button mat-stroked-button class="cancel" mat-dialog-close [innerText]="'MAIN_APP_DIALOG.INPUT_DIALOG.cancel' | translate"></button>
  </mat-dialog-actions>
</mat-card>
